import mixpanel from 'mixpanel-browser';
var projectToken = process.env.NODE_ENV === 'production'
    ? '5cae28b752786010f56171a9b5ec3c56'
    : 'c9b4635b2a95f3096b5445621a37ff51';
mixpanel.init(projectToken, {
    debug: new URLSearchParams(window.location.search).has('debug-mixpanel'),
    api_host: '/mp',
});
if (process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === undefined ||
    window.playwright)
    mixpanel.disable();
export default mixpanel;
